<script lang="ts">
    import {getLocalization, getLogger} from 'src/core';
    import KpContextMenuButton from 'shared/components/kp-context-menu/KpContextMenuButton.svelte';
    import {assertExists} from 'shared/utils/custom-utils';

    const logger = getLogger();
    const localize = getLocalization();

    export let inputElement: HTMLInputElement | HTMLTextAreaElement;

    const handleCopy = async () => {
        if (inputElement) {
            try {
                await navigator.clipboard.writeText(inputElement.value);
            } catch (err) {
                logger.error('Failed to copy:', err);
            }
        }
    }

    const handlePaste = async () => {
        if (inputElement) {
            try {
                const text = await navigator.clipboard.readText();
                const start = inputElement.selectionStart || 0;
                const end = inputElement.selectionEnd || 0;
                const value = inputElement.value;

                inputElement.value = value.slice(0, start) + text + value.slice(end);
                dispatchInputEvent()
                inputElement.setSelectionRange(start + text.length, start + text.length);
            } catch (err) {
                logger.error('Failed to paste:', err);
            }
        }
    }

    const handleCut = async () => {
        if (inputElement) {
            try {
                const start = inputElement.selectionStart || 0;
                const end = inputElement.selectionEnd || 0;
                const selectedText = inputElement.value.slice(start, end);

                await navigator.clipboard.writeText(selectedText);
                const value = inputElement.value;
                inputElement.value = value.slice(0, start) + value.slice(end);
                dispatchInputEvent();
            } catch (err) {
                logger.error('Failed to cut:', err);
            }
        }
    }

    const handleSelectAll = () => {
        if (inputElement) {
            inputElement.select();
        }
    }

    const dispatchInputEvent = () => {
        assertExists(inputElement);
        const inputEvent = new InputEvent('input', {
            bubbles: true,
            cancelable: false
        });
        inputElement.dispatchEvent(inputEvent);
    }
</script>

<KpContextMenuButton icon="copy" on:click={handleCopy}>
    {localize(/* @kp-localization commons.Zkopirovat */ 'commons.Zkopirovat')}
</KpContextMenuButton>

<KpContextMenuButton icon="paste" on:click={handlePaste}>
    {localize(/* @kp-localization commons.Paste */ 'commons.Paste')}
</KpContextMenuButton>

<KpContextMenuButton icon="scissors" on:click={handleCut}>
    {localize(/* @kp-localization commons.Cut */ 'commons.Cut')}
</KpContextMenuButton>

<KpContextMenuButton icon="text-width" on:click={handleSelectAll}>
    {localize(/* @kp-localization commons.SelectAll */ 'commons.SelectAll')}
</KpContextMenuButton>